/*
 * Buy 1 Get 1 (BOGO)
 *
 * Behaviour:
 *  1. Every item added through an add-to-cart form (the "Buy 1 Get 1 Free on UPI
 *     Payment" button) is tagged with a hidden line item property `_bogo: buy`.
 *  2. When the customer clicks "View cart" or "Check out", a matching free
 *     counterpart (`_bogo: free`, same variant) is added for each tagged item so
 *     that every bought item is paired with one more of the same item.
 *
 * The logic is idempotent: the free quantity is always synced to equal the
 * bought quantity, so clicking View cart and then Check out never adds extras.
 *
 * NOTE: the counterpart is added at the variant's normal price. To make it
 * actually free, configure a matching "Buy X get Y free" automatic discount in
 * Shopify Admin > Discounts.
 */
(function () {
  const PROP = '_bogo';
  const BUY = 'buy';
  const FREE = 'free';

  let syncing = false;

  const cartUrl = () => (window.routes && window.routes.cart_url) || '/cart';
  const cartAddUrl = () => (window.routes && window.routes.cart_add_url) || '/cart/add';

  // 1. Tag items added via any add-to-cart form. Runs in the capture phase so
  //    the hidden input is in the DOM before product-form.js builds its FormData.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      if (form.querySelector(`input[name="properties[${PROP}]"]`)) return;

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${PROP}]`;
      input.value = BUY;
      form.appendChild(input);
    },
    true
  );

  // Add the missing free counterparts for every tagged ("buy") line.
  async function syncBogo() {
    const cart = await fetch(`${cartUrl()}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());

    const buyQty = {};
    const freeQty = {};
    (cart.items || []).forEach((item) => {
      const tag = item.properties && item.properties[PROP];
      if (tag === BUY) buyQty[item.variant_id] = (buyQty[item.variant_id] || 0) + item.quantity;
      else if (tag === FREE) freeQty[item.variant_id] = (freeQty[item.variant_id] || 0) + item.quantity;
    });

    const items = [];
    Object.keys(buyQty).forEach((variantId) => {
      const missing = buyQty[variantId] - (freeQty[variantId] || 0);
      if (missing > 0) {
        items.push({ id: Number(variantId), quantity: missing, properties: { [PROP]: FREE } });
      }
    });

    if (!items.length) return;

    await fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
  }

  function proceedToCheckout(button) {
    const form = button.form || button.closest('form');
    if (!form) {
      window.location.href = `${cartUrl()}?checkout`;
      return;
    }
    if (typeof form.requestSubmit === 'function') {
      // Keeps the submitter (name="checkout") so Shopify redirects to checkout.
      form.requestSubmit(button);
    } else {
      if (!form.querySelector('input[name="checkout"]')) {
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'checkout';
        hidden.value = '';
        form.appendChild(hidden);
      }
      form.submit();
    }
  }

  // 2. Intercept "View cart" and "Check out", sync the BOGO items, then proceed.
  document.addEventListener(
    'click',
    (event) => {
      if (syncing) return;

      const checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"]');
      const viewCartLink = event.target.closest(
        '#cart-icon-bubble, #cart-notification-button, cart-notification a[href], cart-drawer a[href]'
      );

      let proceed = null;
      if (checkoutButton) {
        proceed = () => proceedToCheckout(checkoutButton);
      } else if (viewCartLink) {
        const href = viewCartLink.getAttribute('href') || '';
        if (!/\/cart(\?|#|$|\.js)/.test(href) && !/\/checkout/.test(href)) return;
        proceed = () => {
          window.location.href = viewCartLink.href;
        };
      } else {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      syncing = true;
      syncBogo()
        .catch((error) => console.error('BOGO sync failed:', error))
        .finally(() => {
          syncing = false;
          proceed();
        });
    },
    true
  );
})();